import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export function useReplenDraftOrderEffect({
  replenGridData,
  usageDetails,
  patientDetails,
  filteredProduct,
  myCaseResourceType,
  reportUsageFormObj,
  reportUsagePatientDetails,
  countryCode,
  surgeryNumber,
  createRecordAndReplenDraftOrderObj,
  setReportUsageFormObj,
}) {
  useEffectWithErrorLogging(() => {
    if (
      replenGridData.length > 0 &&
      replenGridData.some(
        (x) =>
          x.shippingDetails &&
          Object.keys(x.shippingDetails).length > 0
      )
    ) {
      const updatedObj = createRecordAndReplenDraftOrderObj(
        usageDetails,
        patientDetails,
        filteredProduct,
        replenGridData,
        myCaseResourceType,
        reportUsageFormObj,
        reportUsagePatientDetails,
        countryCode,
        surgeryNumber
      );
      setReportUsageFormObj({ ...reportUsageFormObj, ...updatedObj });
    }
  }, [replenGridData]);
}